function updateCartBadges() {
  fetch('/cart.js')
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      var qtys = {};
      cart.items.forEach(function(item) {
        qtys[item.product_id] = (qtys[item.product_id] || 0) + item.quantity;
      });
      document.querySelectorAll('.cart-qty-badge').forEach(function(badge) {
        var pid = parseInt(badge.dataset.productId);
        var qty = qtys[pid] || 0;
        if (qty > 0) {
          badge.querySelector('.badge-qty').textContent = qty;
          badge.classList.add('visible');
        } else {
          badge.querySelector('.badge-qty').textContent = '';
          badge.classList.remove('visible');
        }
      });
    });
}

// Carga inicial
updateCartBadges();

// Escucha todos los eventos posibles del carrito en Horizon
document.addEventListener('cart:updated', updateCartBadges);
document.addEventListener('cart:refresh', updateCartBadges);
document.addEventListener('dispatch:cart-update', updateCartBadges);
document.addEventListener('on:cart:add', updateCartBadges);
document.addEventListener('on:cart:change', updateCartBadges);

// Observador para detectar cambios en el contador del carrito del header
var cartObserver = new MutationObserver(function() {
  updateCartBadges();
});

function initObserver() {
  var cartCount = document.querySelector('[data-cart-count], .cart-count, cart-count, .cart-item-count');
  if (cartCount) {
    cartObserver.observe(cartCount, { childList: true, subtree: true, characterData: true });
  }
}

document.addEventListener('DOMContentLoaded', initObserver);
setTimeout(initObserver, 1000);
